import { NavigateFunction } from "react-router-dom";
import * as Yup from "yup";
import { TUseTranslationTfn } from "../../data/AppType";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  encryptData,
  handleError,
  sweetAlertError,
  toastError,
  toastSuccess,
} from "../../utils/AppFunctions";
import { routePublic } from "../../routes/PublicRoutePath";
import { FORGOT_PASSWORD } from "../../services/Endpoints";
import { BIT_VALUE } from "../../utils/AppEnumerations";

export interface IForgotPassForm {
  username: string;
}

export const validationSchemaForgotPassword = Yup.object({
  username: Yup.string().required("Username is required!"),
});

export const initialValuesForgotPassword = {
  username: "",
};

export const submitForgotPassword = async (
  values: IForgotPassForm,
  navigation: NavigateFunction,
  t: TUseTranslationTfn
) => {
  try {
    const { username } = values;
    const payload = { username: username };

    const forgotPassword = await FORGOT_PASSWORD(payload);
    if (forgotPassword && forgotPassword.code === DEFAULT_STATUS_CODE_SUCCESS) {
      toastSuccess(forgotPassword.message);
      navigation(
        `/${routePublic.verifyOtp}?us=${encryptData(
          `${username}|${BIT_VALUE.One}`
        )}`
      );
    } else {
      sweetAlertError({
        message: forgotPassword?.data.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (e: any) {
    toastError(e?.resultLogin?.data.title || MESSAGE_UNKNOWN_ERROR_OCCURRED);
    handleError(e, "submitForgotPassword");
  }
};
